import { Suspense } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import store from './store';
import Framework from './component/framework';
import AccessCheck from '@component/AccessCheck';
import HomePage from './views/HomePage';
import RoomPage from './views/Room';
import SuspencePage from './views/Suspence';
import { DebugPanel } from '@component/debug';

import './utils/i18n';
import './styles/globals.css';

// import RequireJoin from '@component/require-join';

function App() {
  return (
    /* FIXME: 弄清楚这里 Suspense 的作用 */
    /* 使用 i18next-http-backend 动态引入翻译文件后，必须要加 Suspense */
    <Suspense fallback="">
      <Provider store={store}>
        <Framework>
          <BrowserRouter basename={process.env.REACT_APP_BASENAME}>
            <Routes>
              {/* 主页 */}
              <Route
                path="/"
                element={
                  <AccessCheck>
                    <HomePage />
                  </AccessCheck>
                }
              />

              {/* <Route path="/entering" element={<EnteringPage />} /> */}

              {/* important: 进会页、会议室页公用一个路由 */}
              <Route
                path="/:meetingCode"
                element={
                  // <RequireJoin>
                  <AccessCheck>
                    <RoomPage />
                  </AccessCheck>
                  // </RequireJoin>
                }
              />
              {/* 移动端提示页 */}
              <Route path="/suspence" element={<SuspencePage />} />
            </Routes>
          </BrowserRouter>

          {process.env.REACT_APP_DEBUG_TOOL && <DebugPanel />}
        </Framework>
      </Provider>
    </Suspense>
  );
}

export default App;
